export enum TicketStatus {
    Locked = 'L ',
    Refunded = 'N ',
    Changed = 'R ',
    Pending = 'S ',
    Returned = 'T ',
    Active = 'Y ',
    CONFIRMED = 'CONFIRMED',
    AWAITING_REACTIVATION = 'AWAITING_REACTIVATION',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED',
    LENT = 'LENT'
}

export enum FareContractStatus {
    UNKNOWN = 'UNKNOWN',
    CONFIRMED = 'CONFIRMED',
    ACTIVE = 'ACTIVE',
    AWAITING_REACTIVATION = 'AWAITING_REACTIVATION',
    CONSUMED = 'CONSUMED',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
    BLOCKED = 'BLOCKED',
    EXPIRED = 'EXPIRED',
    INVALID = 'INVALID',
    PENDING = 'PENDING'
}

export const FareContractToTicketsStatusMap = new Map<FareContractStatus, TicketStatus | string>([
    [FareContractStatus.UNKNOWN, ''],
    [FareContractStatus.CONFIRMED, TicketStatus.CONFIRMED],
    [FareContractStatus.ACTIVE, TicketStatus.Active],
    [FareContractStatus.AWAITING_REACTIVATION, TicketStatus.AWAITING_REACTIVATION],
    [FareContractStatus.CONSUMED, TicketStatus.Active],
    [FareContractStatus.CANCELLED, TicketStatus.Refunded],
    [FareContractStatus.REFUNDED, TicketStatus.Returned],
    [FareContractStatus.BLOCKED, TicketStatus.Refunded],
    [FareContractStatus.EXPIRED, ''],
    [FareContractStatus.INVALID, TicketStatus.Refunded],
    [FareContractStatus.PENDING, TicketStatus.Pending]
]);
